import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { getHeadingIdsToElements } from '@confluence/editor-heading-links';

export const useScrollOnUrlChange = (hasProseMirrorRendered: boolean) => {
	const { hash } = useLocation();

	useEffect(() => {
		if (!hasProseMirrorRendered) {
			return;
		}

		if (!hash) {
			return;
		}

		const id = hash.slice(1);

		const element = document.getElementById(id);
		// Indicates anchor
		if (element) {
			element.scrollIntoView();
		}

		const headingIdToElement = getHeadingIdsToElements();
		const scrollContainer = document.getElementsByClassName(
			'fabric-editor-popup-scroll-parent',
		)?.[0];

		// The top of the heading element
		const headingTop = headingIdToElement.get(id)?.getBoundingClientRect()?.top;
		// The top of the scroll container
		const scrollContainerTop = scrollContainer?.getBoundingClientRect()?.top;
		// The current scroll position
		const offset = scrollContainer?.scrollTop;

		if (headingTop === undefined || scrollContainerTop === undefined || offset === undefined) {
			return;
		}

		// Subtract the scroll container position from the heading position to get the scroll distance
		// and add the offset to account for current scroll position
		const scrollToY = headingTop - scrollContainerTop + offset;

		scrollContainer?.scrollTo({
			left: 0,
			top: scrollToY,
			behavior: 'smooth',
		});
	}, [hash, hasProseMirrorRendered]);
};
